// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"ErrorPage_errorPageWrapper__1bPgi","showboatLogo":"ErrorPage_showboatLogo__2z4je"};